// extracted by mini-css-extract-plugin
export default {"link":"HeaderLink_link__B7atW"};